import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { DashboardView } from "@/components/dashboard";
import { ADMIN_ME_QUERY_KEY, adminStatsQueryKey } from "@/lib/admin-queries";
import { adminApi } from "@/lib/api";

function DashboardRoute() {
  // The gate in __root.tsx has already resolved this; reading the same cache key
  // returns it synchronously (no extra request).
  const meQuery = useQuery({ queryKey: ADMIN_ME_QUERY_KEY, queryFn: () => adminApi.me() });
  const statsQuery = useQuery({ queryKey: adminStatsQueryKey(), queryFn: () => adminApi.stats() });
  return <DashboardView actor={meQuery.data?.actor ?? "…"} stats={statsQuery.data} />;
}

export const Route = createFileRoute("/")({ component: DashboardRoute });
